export const awsConfigProd = {
  Auth: {
    Cognito: {
      region: "ap-south-1",
      userPoolId: "ap-south-1_Vhd8rxTNq",
      userPoolClientId: "18s99bv6b91j380g83ja4pq3b0",
      loginMechanisms: ["username", "email"],
      oauth: {
        domain:
          "riddhi-prod-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com",
        scope: [
          "phone",
          "openid",
          "profile",
          "email",
          "api.crm.riddhi.co.in/admin",
          "api.crm.riddhi.co.in/read",
          "api.crm.riddhi.co.in/write",
          "aws.cognito.signin.user.admin",
        ],
        redirectSignIn: ["http://abovehead.com"],
        redirectSignOut: ["http://abovehead.com"],
        responseType: "code",
      },
    },
  },
  Api: {
    ProvisionEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/admin/provision/client",
    ClientsEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/admin/clients",
    ClientGoalsEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/admin/clients",
    ClientOwnGoalsEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/client",
    ClientPlanningReviewsEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/admin/clients",
    ClientAssetsEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/admin/clients",
    HealthReportEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/client/healthreport",
    RegistrationEndpoint:
      "https://9roq8t9a86.execute-api.ap-south-1.amazonaws.com/Prod/api/v1/public/register",
  },
  HealthReport: {
    ApiKey: "hr_a346c234a3e24a66b58c09fa64d41244", // Replace with actual prod API key
    RateLimit: {
      maxRequests: 10,
      windowMs: 60000, // 1 minute
    },
  },
  Registration: {
    ApiKey: "reg_a1585e8e99c94725a052ee2931c2f70e", // Prod API key (update when available)
    RateLimit: {
      maxRequests: 20,
      windowMs: 60000, // 1 minute
    },
  },
  // federationDisabled: true,
};

console.log("AWS Config:", {
  region: process.env.VUE_APP_AWS_REGION,
  userPoolId: process.env.VUE_APP_USER_POOL_ID,
  clientId: process.env.VUE_APP_CLIENT_ID,
});

// export default awsConfig;
